import { default as NextLink } from "next/link"
import { useParsedUrl } from "@/lib/hooks/useParsedUrl"
import Block from "@/components/wrappers/block"
import Button from "@/common/button/button"
import Arrow from "@/common/icons/arrow"
import Download from "@/common/icons/download"
import OpenInNew from "@/common/icons/open-in-new"
import styles from "./link.module.css"
import classNames from "classnames"

export default function Link({ block, settings }) {
  const { variant, isButton, noLink } = settings

  const url = useParsedUrl({
    url: block.attrs?.link?.url,
    autoAppend: block.attrs?.autoAppendParams
  })

  if (!block?.attrs?.text) {
    return null
  }

  if (!url && !noLink) {
    return null
  }

  const dataProps = {}
  const hasInnerWrapper = ["arrow-block"]
  const isExternal = url?.startsWith("http") || block.attrs.link.target

  if (block?.attrs?.ssoToggle) {
    dataProps["data-service"] = block?.attrs?.ssoToggle
  }

  return (
    <LinkElem link={block?.attrs?.link} isExternal={isExternal} noLink={noLink}>
      {isButton && (
        <Button theme={block?.attrs?.theme ?? "text"}>
          {block?.attrs?.text}
        </Button>
      )}
      {!isButton && (
        <Block
          block={block}
          noStyling={true}
          className={classNames(styles.link, variant, {
            "is-button": isButton,
            "toggle-sso-modal": block?.attrs?.ssoToggle
          })}
          dataProps={dataProps}>
          {hasInnerWrapper.includes(variant) && (
            <span>{block?.attrs?.text}</span>
          )}
          {!hasInnerWrapper.includes(variant) && block?.attrs?.text}
          {variant === "arrow-block" && (
            <div className="icon">
              {block?.attrs?.download ? (
                <Download className="w-4.5" />
              ) : (
                <Arrow />
              )}
            </div>
          )}
          {variant === "text-w-icon" && isExternal && (
            <div className="open-in-new">
              <OpenInNew />
            </div>
          )}
        </Block>
      )}
    </LinkElem>
  )
}

export const LinkElem = ({ link, isExternal, children, noLink, className }) => {
  if (noLink) {
    return children
  }

  const rel = link.sponsored ? "sponsored" : link.nofollow ? "nofollow" : ""

  const attrs = {
    href: link.url,
    target: link.target ? "_blank" : "_self",
    rel: rel,
    className: className
  }

  return !isExternal ? (
    <NextLink href={link?.url} prefetch={false} className={className}>
      {children}
    </NextLink>
  ) : (
    <a {...attrs}>{children}</a>
  )
}
